
import { Component, Vue } from "vue-property-decorator";
import { ComponentInterface, ComponentStatus } from "@/services/Dev-scrum/interfaces";
import DevScrumRepository from "@/services/Dev-scrum";
import CreateComponentForm from "@/services/Dev-scrum/forms/CreateComponentForm";

@Component({
  inject: [
    'devScrumRepository',
  ],
})
export default class CreateComponent extends Vue {
  private readonly devScrumRepository: DevScrumRepository;
  private components: ComponentInterface[] = [];
  private inputRefs: HTMLElement[] = [];
  private submitted = false; // flag to track whether the form has been submitted

  private forms = [
    new CreateComponentForm(),
  ];
  private cols = 12;
  private md = 4;

  private addForm(): void {
    this.forms.push(new CreateComponentForm());

    this.$nextTick(() => {
      const newIndex = this.forms.length - 1;
      const nextInput = this.inputRefs[newIndex] as any;
      if (nextInput) {
        nextInput.focus();
      }
    });
  }

  private get statusOptions() {
    return Object.values(ComponentStatus).map((value: string) => ({ name: value }));
  }

  private removeForm(): void {
    if (this.forms.length > 1) {
      this.forms.pop();
    }
  }

  public async submitAudit(): Promise<void> {
    const newForms = this.forms.map(form => {
      return {
        name: form.name,
        status: form.status || ComponentStatus.ACTIVE,
      };
    });
    if (newForms.length === 1) {
      await this.devScrumRepository.createComponent(newForms[0].name, newForms[0].status);
    } else {
      await this.devScrumRepository.createComponents(newForms);
    }

    this.submitted = true;

    setTimeout(() => {
      this.submitted = false;
      this.resetForm();
    }, 1000);

  }

  private setInputRef(el: HTMLElement | null, index: number): void {
    if (el) {
      this.$set(this.inputRefs, index, el);
    } else {
      this.inputRefs.splice(index, 1);
    }
  }


  private resetForm(): void {
    this.forms = [
      new CreateComponentForm(),
    ];
  }
}
